/**
 * Fait : l'écran qui dit qu'un lien de courriel est arrivé abîmé, et ce qu'il
 *   faut faire ensuite.
 *
 *   POURQUOI IL EXISTE : un client de messagerie qui coupe une longue adresse
 *   à la ligne produit un fragment qui ne correspond plus à aucune route.
 *   Sans cet écran, la personne retombait sur l'entrée de l'atelier SANS UN
 *   MOT — elle croyait devoir se connecter, avec un compte qu'elle n'a pas
 *   encore, ou un mot de passe qu'elle a justement oublié. C'est le défaut
 *   d'origine du chantier, fermé pour le lien intact et resté ouvert pour le
 *   lien abîmé.
 *
 * Ne fait pas : il ne dit RIEN de ce que valait le lien — ni s'il a existé, ni
 *   s'il a expiré, ni à qui il appartenait. Il n'a d'ailleurs pas les moyens
 *   de le savoir : le jeton n'a jamais atteint le serveur.
 */

import { Annonce } from '../gabarits/Annonce.tsx';
import { Partie } from '../gabarits/Partie.tsx';

const AIDE =
  'Certains logiciels de courrier coupent les adresses trop longues. ' +
  'Ce n’est pas votre faute, et rien n’est perdu.';

/** Ce que la personne venait faire, pour lui proposer le bon geste. */
export function PageLienAbime({ pour }: { readonly pour: 'mot-de-passe' | 'inscription' }) {
  const versLOubli = pour === 'mot-de-passe';

  return (
    <div className="empilement" data-etat="erreur" data-ecran="lien-abime">
      <Partie
        etiquette="Ce lien n’est pas complet"
        nature="gens"
        titre="Le lien n’a pas été reçu en entier"
        niveauDeTitre={2}
        aide={AIDE}
        data-role="partie-lien-abime"
      >
        <Annonce urgence="urgent" nature="refus">
          <span data-role="lien-abime">
            L’adresse ouverte est incomplète. Revenez au courriel et vérifiez que vous avez bien
            copié le lien EN ENTIER — il se termine par une longue suite de lettres et de chiffres.
          </span>
        </Annonce>

        {versLOubli ? (
          <p>
            Vous pouvez aussi{' '}
            <a href="#/oubli" data-role="vers-l-oubli">
              demander un nouveau lien
            </a>{' '}
            : c’est immédiat, et le précédent cesse alors de servir.
          </p>
        ) : (
          <p>
            Si vous n’y arrivez pas, demandez à la personne qui vous a invité(e) de vous renvoyer
            son invitation.
          </p>
        )}

        <p>
          <a href="#/" data-role="vers-la-connexion">
            Revenir à l’écran d’entrée
          </a>
        </p>
      </Partie>
    </div>
  );
}
